import { getRefundsArchiveList } from "./api";
import { errorGenerator } from "../system/utils";
import { typeRefundsArchiveFilters } from "./reducer";
import { call, put, takeLatest } from "redux-saga/effects";
import { dashboardLoaderAC } from "../system/systemActionCreators";
import {
  dRefundsArchiveSetDataAC,
  dRefundsArchiveSetDataSagaAC,
  dRefundsArchiveSetPaginationAC,
} from "./actionCreators";
import { typePagination, typeRequestPagination } from "../system/constants";

export const paginationMapper = (paginationObject: any): typePagination => {
  return {
    pageNumber: paginationObject.pageNumber,
    pageCount: paginationObject.totalPages,
    totalItems: paginationObject.totalElements,
    isFirstPage: paginationObject.pageNumber === 0,
    isLastPage: paginationObject.pageNumber + 1 === paginationObject.totalPages,
  };
};

function* getData(payload: {
  filters: typeRefundsArchiveFilters;
  paginationRequest: typeRequestPagination;
}) {
  let response = yield call(getRefundsArchiveList, payload);

  if (response.status === 200) {
    const pagination: typePagination = paginationMapper(response.data);

    yield put(dRefundsArchiveSetPaginationAC(pagination));

    yield put(dRefundsArchiveSetDataAC(response.data.content));
  } else {
    yield errorGenerator(response);
  }
}

export function* dRefundsSetDataWorker(actionObject: {
  type: string;
  payload: {
    filters: typeRefundsArchiveFilters;
    paginationRequest: typeRequestPagination;
  };
}) {
  yield put(dashboardLoaderAC(true));

  yield getData(actionObject.payload);

  yield put(dashboardLoaderAC(false));
}

export function* dRefundsArchiveSetDataWatcher() {
  yield takeLatest(dRefundsArchiveSetDataSagaAC.type, dRefundsSetDataWorker);
}
